let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1NKZf")).then(() => parcelRequire('byS2e'));